import React, { Component } from "react";
import List from "@material-ui/core/List";
import { Skeleton } from "@material-ui/lab";
import { Box } from "@material-ui/core";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { withStyles } from "@material-ui/core/styles";
import CheckboxTree from "react-checkbox-tree";

import fetchAPI from "../../../../../../components/utils/fetchAPI";

import "react-checkbox-tree/lib/react-checkbox-tree.css";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
});

class SimpleCard extends Component {
  state = {
    data: [],
    dataBackup: [],
    filter: [],
    filterBackup: [],
    checked: [],
    checkedBackup: [],
    expanded: [],
    flagMasive: [],
    searchValue: "",
    loading: true,
  };

  componentDidMount = async () => {
    await this.getData();
  };

  recursiveConstructDataSegments = async (
    arr,
    field,
    index,
    data,
    dataBackup
  ) => {
    const { id, name } = field;
    const channelIndex = data.findIndex((element) => element.value === name);
    if (channelIndex < 0) {
      data.push({
        value: name,
        label: name,
        children: [
          {
            value: id,
            label: id,
          },
        ],
      });
      dataBackup.push(id);
    } else {
      data[channelIndex].children.push({
        value: id,
        label: id,
      });
      dataBackup.push(id);
    }
    if (index + 1 < arr.length)
      return this.recursiveConstructDataSegments(
        arr,
        arr[index + 1],
        index + 1,
        data,
        dataBackup
      );
    return { data, dataBackup };
  };

  getData = async () => {
    await fetchAPI({
      service: this.props.service,
      protocol: "GET",
      callbackThen: async (response) => {
        const { data, dataBackup } = await this.recursiveConstructDataSegments(
          response,
          response[0],
          0,
          [],
          []
        );
        this.setDataState(data);
        this.setState({
          dataBackup,
          loading: false,
        });
      },
    });
  };

  setDataState = (data) => {
    this.setState({
      data: data,
      filter: data,
    });
  };

  backupChecked = (val = true) => {
    let checkedBackup = [];
    if (val) {
      checkedBackup = [
        ...(this.state.checkedBackup || []),
        ...(this.state.checked || []),
      ];
    }
    this.setState({
      checkedBackup,
    });
  };

  emiteRules = () => {
    const keys = {};
    const checked = [
      ...new Set([
        ...(this.state.checkedBackup || []),
        ...(this.state.checked || []),
      ]),
    ];
    keys[this.props.property] = checked
    this.props.setRules([this.props.property], keys);
  };

  removeKeyOfBackupChecked = (keys) => {
    const backup = this.state.checkedBackup.filter(
      (key) => !keys.includes(key)
    );
    this.setState({
      checkedBackup: backup,
    });
  };

  recursiveExtractKeys = async (arr, element, index, data) => {
    if (!element) return data;
    data.push(element.value);
    return this.recursiveExtractKeys(arr, arr[index + 1], index + 1, data);
  };

  handleCheckSingle = async (checked, targetNode = null) => {
    let removeKeys = [];
    if (targetNode)
      if (!targetNode.checked) {
        if (targetNode.isSelectedAll) {
          const keys = await this.recursiveSelected(
            this.state.filter,
            this.state.filter[0],
            0,
            []
          );
          removeKeys = keys;
        } else if (targetNode.children) {
          removeKeys = await this.recursiveExtractKeys(
            targetNode.children,
            targetNode.children[0],
            0,
            []
          );
        } else {
          removeKeys = [targetNode.value];
        }
      }
    await this.removeKeyOfBackupChecked(removeKeys);
    if (!checked) {
      this.setState({
        checked: [
          ...new Set([
            ...(this.state.checkedBackup || []),
            ...(this.state.checked || []),
          ]),
        ],
      });
    } else {
      this.setState({ checked });
      this.backupChecked();
    }
    // this.props.checkedValuesOfices(checked);
  };

  recursiveSelected = async (arr, ele, index, selectedElement) => {

    let arrSelected = selectedElement;

    if (!ele) return arrSelected;
    const element = JSON.parse(JSON.stringify(ele));
    if (element.hasOwnProperty("children")) {
      const chilSelected = await this.recursiveSelected(
        element.children,
        element.children[0],
        0,
        []
      );
      if (chilSelected && chilSelected.length > 0) {
        arrSelected = [...arrSelected, ...chilSelected];
      }
    } else {
      const valueElement = (element.value).toString();
      arrSelected.push(valueElement);
    }
    if (index + 1 < arr.length)
      return this.recursiveSelected(arr, arr[index + 1], index + 1, arrSelected);
    return arrSelected;
  };

  handleSelectAll = async (e) => {
    let selectedElement = await this.recursiveSelected(
      this.state.filter,
      this.state.filter[0],
      0,
      []
    );
    if (!e.target.checked) {
      selectedElement = [...new Set([...(this.state.checked || []), ...selectedElement])];
    } else if (this.state.checked) {
      selectedElement = this.state.checked.filter((key) => !selectedElement.includes(key));
    }
    this.handleCheckSingle(selectedElement, {
      checked: !e.target.checked,
      isSelectedAll: true,
    });
  };

  isCheckAll = () => {
    if (!this.state.checked) return false;
    if (this.state.checked && this.state.checked.length === 0) return false;
    if (this.state.checked.length > 0)
      return (
        this.state.checked.filter((element) =>
          (this.state.searchValue === "" ||
          this.state.searchValue === null ||
          this.state.searchValue === undefined
            ? this.state.dataBackup
            : this.state.filterBackup
          ).includes(element)
        ).length ===
        (this.state.searchValue === "" ||
        this.state.searchValue === null ||
        this.state.searchValue === undefined
          ? this.state.dataBackup
          : this.state.filterBackup
        ).length
      );
  };

  handleSearch = async (show) => {
    const label = document.getElementById(
      `exclutions__container-title-card-${this.props.card.id}`
    );

    const buttonSearch = document.getElementById(
      `exclutions__container-button-search-${this.props.card.id}`
    );
    const inputSearch = document.getElementById(
      `exclutions__container-input-search-${this.props.card.id}`
    );

    label.style.display = show ? "none" : "block";
    buttonSearch.style.display = show ? "none" : "flex";
    inputSearch.style.display = !show ? "none" : "block";

    if (!show) {
      document.getElementById(
        `exclutions__input-search-${this.props.card.id}`
      ).value = null;
      this.searchValues("");
      this.handleCheckSingle(null);
      this.backupChecked(false);
    } else {
      this.backupChecked();
    }
  };

  recursiveFilter = async (arr, ele, index, search, filter, filterBackup) => {
    if (!ele) return filter;
    const element = JSON.parse(JSON.stringify(ele));
    if (element.hasOwnProperty("children")) {
      const { filter: fil, filterBackup: filbck } = await this.recursiveFilter(
        element.children,
        element.children[0],
        0,
        search,
        [],
        filterBackup
      );
      element.children = fil;
      if (fil.length > 0) {
        filter.push(element);
        filterBackup = [...new Set([...filterBackup, ...filbck])];
      }
    } else {
      if (element.label.toLowerCase().includes(search)) {
        filter.push(element);
        const valueElement = element.value;
        filterBackup.push(valueElement);
      }
    }
    if (index + 1 < arr.length)
      return this.recursiveFilter(
        arr,
        arr[index + 1],
        index + 1,
        search,
        filter,
        filterBackup
      );
    return { filter, filterBackup };
  };

  searchValues = async (value) => {
    const { filter, filterBackup } = await this.recursiveFilter(
      this.state.data,
      this.state.data[0],
      0,
      value.toLowerCase(),
      [],
      []
    );
    this.setState({
      filter:
        value === null || value === "" || value === ""
          ? this.state.data
          : filter,
      filterBackup,
      searchValue: value,
    });
    this.handleCheckSingle(false);
  };
  
  handleInput = (e) => {
    let text = e.target.value;
    this.searchValues(text);
  };

  masiveCheck = (arrKeys) => {
    this.setState({
      flagMasive: arrKeys,
      checked: arrKeys,
      checkedBackup: [],
    });
  };

  render() {
    if (this.state.flagMasive !== this.props.card.rules) {
      this.masiveCheck(this.props.card.rules);
    }
    const idCardContainer = "card-exclutions-container-" + this.props.card.id;

    const classCard = this.state.yellow
      ? `exclutions__card exclutions__card--clients-type`
      : this.state.grey
      ? `exclutions__card exclutions__card--zone`
      : `exclutions__card exclutions__card--sales-manager`;

    const idList = "card-exclutions-list-" + this.props.card.id;

    const styleBox = {
      height: "236px",
    };

    const subheaderList = (
      <ListSubheader component="div">
        <ListItemIcon>
          <Checkbox
            edge="start"
            style={
              this.props.card.id !== "zone" && this.props.card.id !== "clients"
                ? { padding: "0 2rem 0 2rem" }
                : {}
            }
            disableRipple
            checked={this.isCheckAll()}
            id={this.props.card.id}
            onClick={this.handleSelectAll}
          />
        </ListItemIcon>
        <div
          className={
            this.props.card.id !== "zone" && this.props.card.id !== "clients"
              ? "exclutions__title-search"
              : "exclutions__depended-title-search"
          }
        >
          <ListItemText
            id={`exclutions__container-title-card-${this.props.card.id}`}
            primary={this.props.card.title}
            style={
              this.props.card.id !== "zone" && this.props.card.id !== "clients"
                ? { paddingLeft: "1.8rem" }
                : {}
            }
          />
          <div
            id={`exclutions__container-input-search-${this.props.card.id}`}
            className="exclutions__container-input-search"
          >
            <input
              type="text"
              id={`exclutions__input-search-${this.props.card.id}`}
              className="exclutions__input-search"
              onKeyUp={this.handleInput}
            />
            <ClearIcon
              className="exclutions__icon-clear"
              data-id={this.props.card.id}
              onClick={(e) => this.handleSearch(false)}
            />
          </div>
        </div>
        <ListItemIcon
          id={`exclutions__container-button-search-${this.props.card.id}`}
        >
          <SearchIcon
            data-id={this.props.card.id}
            onClick={(e) => this.handleSearch(true)}
          />
        </ListItemIcon>
      </ListSubheader>
    );

    return (
      <div id={idCardContainer} className={classCard}>
        <div className="exclutions__card__overlay"></div>
        <Box style={styleBox}>
          <List id={idList} subheader={subheaderList}>
            {/* <BootstrapTooltip 
            TransitionComponent={Zoom}
            placement="top"
            title="Al seleccionar, estas activando la inclusión"
          > */}
            {this.state.loading && (
              <>
                {Array(5)
                  .fill(2)
                  .map((x) => (
                    <Skeleton
                      key={`skeleton_${this.props.card.id}_${x}`}
                      animation="wave"
                      height={"35px"}
                      style={{ marginLeft: "5px", marginRight: "5px" }}
                    />
                  ))}
              </>
            )}
            <CheckboxTree
              icons={{
                check: (
                  <svg
                    class="MuiSvgIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
                  </svg>
                ),
                uncheck: (
                  <svg
                    class="MuiSvgIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
                  </svg>
                ),
                halfCheck: <AddBoxIcon />, //marcado al marcar una casilla hija
                expandClose: (
                  <svg
                    className="MuiSvgIcon-expandedAndClouded"
                    width="10"
                    height="16"
                    viewBox="0 0 7 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.62695 11.2L5.90279 6.43545L1.62695 1.67095"
                      stroke="#747474"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ),
                expandOpen: (
                  <svg
                    className="MuiSvgIcon-expandedAndClouded"
                    width="16"
                    height="10"
                    viewBox="0 0 13 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.79999 1.62695L6.56449 5.90279L11.329 1.62695"
                      stroke="#747474"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ),
                expandAll: <span className="rct-icon rct-icon-expand-all" />,
                collapseAll: "",
                parentClose: "",
                parentOpen: "",
                leaf: "",
              }}
              nodes={this.state.filter}
              checked={this.state.checked}
              expanded={this.state.expanded}
              onCheck={(checked, targetNode) =>
                this.handleCheckSingle(checked, targetNode)
              }
              onExpand={(expanded) => this.setState({ expanded })}
            />
            {/* </BootstrapTooltip> */}
          </List>
        </Box>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SimpleCard);
